import { useTranslation } from 'react-i18next'

import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

import { useQueryList } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { NonprofitsTable } from './NonprofitsTable/NonprofitsTable'

export function NonprofitsContainer() {
  const { t } = useTranslation()
  const { nonprofitsService } = useServices()
  const [{ data, isLoading, totalResults, errorMessage }, { query, nextPage, previousPage }] = useQueryList(
    nonprofitsService.getNonProfits,
    {}
  )

  useBreadcrumbs([
    {
      label: t('breadcrumb.nonprofits')
    }
  ])

  return (
    <NonprofitsTable
      data={data}
      isLoading={isLoading}
      totalResults={totalResults}
      errorMessage={errorMessage}
      nextPage={nextPage}
      previousPage={previousPage}
      query={query}
    />
  )
}
